export default {"src":"/_next/static/media/offer.6db68d5c.svg","height":95,"width":81,"blurWidth":0,"blurHeight":0};